import React, { Component } from "react";

import Request from "../../core/httpClient";
import styles from "../../css/subfracc.module.css";
const request = new Request();

class CommonAreasEddit extends Component {
	constructor(props) {
		super(props);

		let seleccionados = [];
		const raw = this.props.area.subfraccionamientosSeleccionados;

		if (Array.isArray(raw)) {
			seleccionados = raw;
		} else if (typeof raw === "string") {
			try {
				seleccionados = JSON.parse(raw);
			} catch (e) {
				seleccionados = [];
			}
		}

		this.state = {
			showModal: false,
			nombre: this.props.area.nombre,
			descripcion: this.props.area.descripcion,
			activo: this.props.area.activo,
			id: this.props.area.id_espacio,
			categoria: this.props.area.id_categoria,
			diasPrevios: this.props.area.dias_reserva,
			minutosPrevios: this.props.area.minutos_previos_reserva,
			fianza: this.props.area.fianza,
			tiempoDisponible: this.props.area.dias_maximos_reserva
				? this.props.area.dias_maximos_reserva
				: this.props.area.horas_maximas_reserva,
			isDiasDisponible: this.props.area.dias_maximos_reserva ? true : false,
			imagenArea: this.props.area.area_imagen ? this.props.area.area_imagen : "",
			idSubfrac: seleccionados
				.filter(sub => sub.selected === 1)
				.map(sub => sub.id_subfraccionamiento.toString()),
			subfraccionamientos: this.props.subfraccionamientos, subfraccionamientos: this.props.subfraccionamientos,
			categories: [],
			anuales: this.props.area.max_reservas_anual,
			mensuales: this.props.area.max_reservas_mensual,
			diarias: this.props.area.max_reservas_diaria,
			consecutivas: this.props.area.max_reservas_consecutivas,
			aforo: this.props.area.max_aforo || 1,
			pausar: this.props.area.pausar !== null && this.props.area.pausar !== 0 ? 1 : 0,
			motivo: this.props.area.motivo !== null && this.props.area.motivo !== '' ? this.props.area.motivo : '',
			aforoMax: this.props.area.max_aforo !== null ? true : false,
			maXVivienda: this.props.area.max_reservas_aforo !== null ? this.props.area.max_reservas_aforo : 1,
			subLabel: this.props.subLabel,
			subfraccionamientosSeleccionados: this.props.subfraccionamientosSeleccionados
		};

		this.getCategories();
	}

	componentDidUpdate(prevProps) {

		if (prevProps.area.id_espacio !== this.props.area.id_espacio) {
			this.setState({ id: this.props.area.id_espacio });
		};

		if (prevProps.area.nombre !== this.props.area.nombre) {
			this.setState({ nombre: this.props.area.nombre });
		};

		if (prevProps.area.id_subfraccionamiento !== this.props.area.id_subfraccionamiento) {
			this.setState({ idSubfrac: this.props.area.id_subfraccionamiento ? this.props.area.id_subfraccionamiento : null });
		};

		if (prevProps.area.id_categoria !== this.props.area.id_categoria) {
			this.setState({ categoria: this.props.area.id_categoria });
		};

		if (prevProps.area.fianza !== this.props.area.fianza) {
			this.setState({ fianza: this.props.area.fianza });
		};

		if (prevProps.area.dias_reserva !== this.props.area.dias_reserva) {
			this.setState({ diasPrevios: this.props.area.dias_reserva });
		};

		if (prevProps.area.minutos_previos_reserva !== this.props.area.minutos_previos_reserva) {
			this.setState({ minutosPrevios: this.props.area.minutos_previos_reserva });
		};

		if (prevProps.area.area_imagen !== this.props.area.area_imagen) {
			this.setState({ imagenArea: this.props.area.area_imagen });
		};

		if (prevProps.area.dias_maximos_reserva !== this.props.area.dias_maximos_reserva) {
			this.setState({
				tiempoDisponible: this.props.area.dias_maximos_reserva ? this.props.area.dias_maximos_reserva : this.props.area.horas_maximas_reserva,
				isDiasDisponible: this.props.area.dias_maximos_reserva ? true : false,
			});
		};

		if (prevProps.area.max_reservas_anual !== this.props.area.max_reservas_anual) {
			this.setState({ anuales: this.props.area.max_reservas_anual || '' });
		};

		if (prevProps.area.max_reservas_mensual !== this.props.area.max_reservas_mensual) {
			this.setState({ mensuales: this.props.area.max_reservas_mensual || '' });
		};

		if (prevProps.area.max_reservas_diaria !== this.props.area.max_reservas_diaria) {
			this.setState({ diarias: this.props.area.max_reservas_diaria || '' });
		};

		if (prevProps.area.max_reservas_consecutivas !== this.props.area.max_reservas_consecutivas) {
			this.setState({ consecutivas: this.props.area.max_reservas_consecutivas || '' });
		};

		if (prevProps.area.max_aforo !== this.props.area.max_aforo) {
			this.setState({
				aforo: this.props.area.max_aforo || 1,
				aforoMax: this.props.area.max_aforo !== null ? true : false,
				maXVivienda: this.props.area.max_reservas_aforo !== null ? this.props.area.max_reservas_aforo : 1
			});
		};

		if (prevProps.area.pausar !== this.props.area.pausar) {
			this.setState({ pausar: this.props.area.pausar });
		};

		if (prevProps.area.motivo !== this.props.area.motivo) {
			this.setState({ motivo: this.props.area.motivo || '' });
		};

		if (prevProps.area.activo !== this.props.area.activo) {
			this.setState({ activo: this.props.area.activo });
		};
		if (prevProps.area.subfraccionamientosSeleccionados !== this.props.area.subfraccionamientosSeleccionados) {
			let seleccionados = [];
			const raw = this.props.area.subfraccionamientosSeleccionados;

			if (Array.isArray(raw)) {
				seleccionados = raw;
			} else if (typeof raw === "string") {
				try {
					seleccionados = JSON.parse(raw);
				} catch (e) {
					seleccionados = [];
				}
			}

			this.setState({
				idSubfrac: seleccionados
					.filter(sub => sub.selected === 1)
					.map(sub => sub.id_subfraccionamiento.toString())
			});
		}


	};

	async base64ToUrl(info) {
		try {

			const data = {
				img: info.area_imagen,
				idfrac: localStorage.getItem('frac') || 0,
				id: info.id_area,
				module: "areasComunes"
			};

			const response = await request.post("/commonArea/base64ToUrl", data);

			if (response) {

				if (!response.error) {

					if (info.type === 1) {
						this.setState({ eine1: response.url });
					};

					if (info.type === 2) {
						this.setState({ eine2: response.url });
					};

				};

			};

		} catch (error) {
			console.log(error);
		};
	};

	showPreviewImageCommon() {

		let file = document.getElementById("fileImageEdit").files[0];

		let reader = new FileReader();

		if (file) {

			reader.readAsDataURL(file);

			reader.onloadend = () => {
				this.setState({ imagenArea: reader.result });
				this.updateData({ imagenArea: reader.result });
			};

		};

	};

	async getCategories() {
		try {

			this.setState({ loading: true });

			const data = { id: localStorage.getItem("frac") };

			const response = await request.post("/commonArea/get/categories", data);

			if (response && !response.error) {

				if (response.categories && !response.empty) {
					this.setState({ categories: response.categories });
				};

			} else {

				this.setState({
					error: true,
					message: "",
				});

			};

			this.setState({ loading: false });

		} catch (error) {
			console.log(error);
		};
	};

	async updateData(data) {
		await this.props.updateData(data);
		this.setState(data);
	};

	render() {
		return (
			<div className="full row align-center">
				<div className="column full">
					<div className="column full">
						<div className="white-space-4"></div>
						<div className="input-form-content row full align-center">
							<div className="column label-medium">
								<p>
									<b>Nombre:</b>
								</p>
							</div>
							<div className="column full space">
								<input
									className="input input-modals"
									type="text"
									name="commonArea"
									id="nedit"
									value={this.state.nombre}
									onChange={(event) =>
										this.updateData({ nombre: event.target.value })
									}
									required
									maxLength="150"
									autoComplete="off"
								/>
							</div>
						</div>
						<div className="white-space-8"></div>
						<div className="row full">
							<div className="column full">
								<div className="input-form-content row full align-center">
									<div className="column label-duo-big">
										<p>
											<b>{this.state.subLabel}:</b>
										</p>
									</div>
									<div className="column full">
										<div className={styles["multi-select"]}>
											<label className={styles["multi-label"]}>{this.state.subLabel}:</label>
											<div className={styles["multi-box"]}>
												<label className={styles["multi-option"]}>
													<input
														type="checkbox"
														checked={this.state.idSubfrac.length === this.state.subfraccionamientos.length}
														onChange={(e) => {
															const checked = e.target.checked;
															if (checked) {
																const allIds = this.state.subfraccionamientos.map(sub =>
																	sub.id_subfraccionamiento.toString()
																);
																this.setState({ idSubfrac: allIds });
																this.updateData({ subfraccionamientosSeleccionados: allIds }); 
															} else {
																this.setState({ idSubfrac: [] });
																this.updateData({ subfraccionamientosSeleccionados: [] }); 
															}
														}}
													/>
													TODOS
												</label>

												{this.state.subfraccionamientos.map((sub) => (
													<label key={sub.id_subfraccionamiento} className={styles["multi-option"]}>
														<input
															type="checkbox"
															value={sub.id_subfraccionamiento}
															checked={this.state.idSubfrac.includes(sub.id_subfraccionamiento.toString())}
															onChange={(e) => {
																const value = e.target.value;
																const already = this.state.idSubfrac.includes(value);

																const newSelection = already
																	? this.state.idSubfrac.filter(id => id !== value)
																	: [...this.state.idSubfrac, value];

																this.setState({ idSubfrac: newSelection });
																this.updateData({ subfraccionamientosSeleccionados: newSelection }); // notifica al padre
															}}
														/>
														{sub.nombre}
													</label>
												))}
											</div>
										</div>
									</div>


								</div>
								<div className="white-space-8"></div>
								<div className="input-form-content row full align-center">
									<div className="column label-duo-big">
										<p>
											<b>Días previos: </b>
										</p>
									</div>
									<div className="column full">
										<input
											type="number"
											value={this.state.diasPrevios}
											onChange={(event) =>
												this.updateData({ diasPrevios: event.target.value })}
											name="diasp"
											className="input input-modals text-center"
											autoComplete="off"
											min="0"
										/>
									</div>
								</div>
								<div className="white-space-8"></div>
								<div className="input-form-content row full align-center">
									<div className="column label-duo-big">
										<p>
											<b>Minutos previos: </b>
										</p>
									</div>
									<div className="column full">
										<input
											type="number"
											value={this.state.minutosPrevios}
											onChange={(event) =>
												this.updateData({ minutosPrevios: event.target.value })}
											name="diasp"
											className="input input-modals text-center"
											autoComplete="off"
											min="0"
										/>
									</div>
								</div>
								<div className="white-space-8"></div>
								<div className="group full">
									<div className="input-form-content row full align-center justify-start">
										<div className="row label-duo-big">
											<div className="column">
												<div className="row align-center">
													<label className="container-radio">
														<p>Días disponibles:</p>
														<input
															type="radio"
															name="typeImport"
															checked={this.state.isDiasDisponible}
															onChange={() => this.updateData({ isDiasDisponible: !this.state.isDiasDisponible, tiempoDisponible: this.state.tiempoDisponible })}
														/>
														<span className="checkmarks"></span>
													</label>
												</div>
												<div className="white-space-8"></div>
												<div className="row align-center">
													<label className="container-radio">
														<p>Horas disponibles:</p>
														<input
															type="radio"
															name="typeImport"
															checked={!this.state.isDiasDisponible}
															onChange={() => this.updateData({ isDiasDisponible: !this.state.isDiasDisponible, tiempoDisponible: this.state.tiempoDisponible })}
														/>
														<span className="checkmarks"></span>
													</label>
												</div>
											</div>
										</div>
										<div className="input-form-content row full align-center">
											<input
												type="number"
												name="diasMaximos"
												className="input input-modals text-center"
												required
												min="0"
												autoComplete="off"
												value={this.state.tiempoDisponible}
												onChange={(event) => this.updateData({ tiempoDisponible: event.target.value })}
											/>
										</div>
									</div>
								</div>
								<div className="white-space-8"></div>
								<div className="input-form-content row full align-center">
									<div className="column label-duo-big">
										<p>
											<b>Reservas anuales:</b>
										</p>
									</div>
									<div className="column full">
										<input
											className="input input-modals text-center"
											type="number"
											value={this.state.anuales}
											onChange={(event) =>
												this.updateData({ anuales: event.target.value })
											}
											min="0"
										/>
									</div>
								</div>
								<div className="white-space-8"></div>
								<div className="input-form-content row full align-center">
									<div className="column label-duo-big">
										<p>
											<b>Reservas mensuales:</b>
										</p>
									</div>
									<div className="column full">
										<input
											className="input input-modals text-center"
											type="number"
											value={this.state.mensuales}
											onChange={(event) =>
												this.updateData({ mensuales: event.target.value })
											}
											min="0"
										/>
									</div>
								</div>
								<div className="white-space-8"></div>
								<div className="input-form-content row full align-center">
									<div className="column label-duo-big">
										<p>
											<b>Reservas diarias:</b>
										</p>
									</div>
									<div className="column full">
										<input
											className="input input-modals text-center"
											type="number"
											value={this.state.diarias}
											onChange={(event) =>
												this.updateData({ diarias: event.target.value })
											}
											min="0"
										/>
									</div>
								</div>
								<div className="white-space-8"></div>
								<div className="input-form-content row full align-center">
									<div className="column full">
										<div className="input-form-content row full align-center">
											<div className="column label-duo-big">
												<p>
													<b>Reservas consecutivas:</b>
												</p>
											</div>
											<div className="column full">
												<input
													className="input input-modals text-center"
													type="number"
													value={this.state.consecutivas}
													onChange={(event) => {
														this.updateData({ consecutivas: event.target.value })
													}}
													min="0"
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="white-space-8"></div>
								<div className="row full">
									<div className="row full">
										{!this.state.aforoMax ?
											<div className="input-form-content row full align-center justify-start">
												<div className="row label-duo-big">
													<div className="column">
														<label className="container-check">
															<input
																type="checkbox"
																id="aforoMax"
																checked={this.state.aforoMax ? true : false}
																name="aforoMax"
																onChange={(event) =>
																	this.updateData({ aforoMax: event.target.checked, aforo: 1, maXVivienda: 1 })}
															/>
															<span className="checkmark"></span>
														</label>
													</div>
													<div className="column">
														<h5>
															<b>Aforo máximo</b>
															<i
																className="fas fa-info-circle"
																title="Cantidad máxima de personas que pueden estar en un mismo horario."
																aria-label="Información sobre aforo máximo"
																style={{ marginLeft: 8, cursor: 'help' }}
															/>
														</h5>
													</div>
												</div>
											</div>
											:
											<div className="group full">
												<div className="input-form-content row full align-center justify-start">
													<div className="row label-duo-big">
														<div className="column">
															<label className="container-check">
																<input
																	type="checkbox"
																	id="aforoMax"
																	checked={this.state.aforoMax ? true : false}
																	name="aforoMax"
																	onChange={(event) =>
																		this.updateData({ aforoMax: event.target.checked, aforo: 1, maXVivienda: 1 })}
																/>
																<span className="checkmark"></span>
															</label>
														</div>
														<div className="column">
															<h5>
																<b>Aforo máximo</b>
																<i
																	className="fas fa-info-circle"
																	title="Cantidad máxima de personas que pueden estar en un mismo horario."
																	aria-label="Información sobre aforo máximo"
																	style={{ marginLeft: 8, cursor: 'help' }}
																/>
															</h5>
														</div>
													</div>
													<div className="input-form-content row full align-center">
														<input
															className="input input-modals text-center"
															type="number"
															value={this.state.aforo}
															onChange={(event) => {
																this.updateData({ aforo: parseInt(event.target.value) })
															}}
															min="1"
														/>
													</div>
												</div>
												<div className="white-space-8"></div>
												<div className="input-form-content row full align-center justify-start">
													<div className="row label-duo-big">
														<div className="column">
															<h5>
																<b>Máximo por vivienda</b>
																<i
																	className="fas fa-info-circle"
																	title="Cantidad máxima de personas que una vivienda puede reservar en un mismo horario."
																	aria-label="Información sobre máximo por vivienda"
																	style={{ marginLeft: 8, cursor: 'help' }}
																/>
															</h5>
														</div>
													</div>
													<div className="input-form-content row full align-center">
														<input
															className="input input-modals text-center"
															type="number"
															value={this.state.maXVivienda}
															onChange={(event) => {
																this.updateData({ maXVivienda: parseInt(event.target.value) })
															}}
															min="1"
														/>
													</div>
												</div>
											</div>
										}
									</div>
								</div>
							</div>
							<div className="column full column-img">
								<div className="input-form-content row full align-center space-24">
									<div className="column auto">
										<p>
											<b>Categoría: </b>
										</p>
									</div>
									<div className="column full space-24">
										<select
											name="categoria"
											id=""
											value={this.state.categoria}
											onChange={(event) => this.updateData({ categoria: event.target.value })}
											className="input input-modals"
										>
											{this.state.categories.map((categoria, key) => (
												<option value={categoria.id_categoria} key={key}>
													{categoria.nombre}
												</option>
											))}
										</select>
									</div>
								</div>
								<div className="white-space-8"></div>
								<div className="input-form-content row full align-center space-24">
									<div className="column auto">
										<p>
											<b>Depósito:</b>
										</p>
									</div>
									<div className="column full space-24">
										<input
											className="input input-modals text-center"
											type="number"
											name="fianza"
											value={this.state.fianza}
											onChange={(event) => this.updateData({ fianza: event.target.value })}
											autoComplete="off"
										/>
									</div>
								</div>
								<div className="white-space-16"></div>
								<div className="responsive-img justify-end row">
									<div className="container-img justify-center">
										<img
											src={
												this.state.imagenArea
													? this.state.imagenArea
													: require('../../img/empty_image.png')
											}
											className="img-duo-preview"
											id="previewAreaEdit"
										/>

										<div className="middle-overlay">
											<label className="btn-upload-image column align-center justify-center">
												<i className="fas fa-file-upload"></i>
												<input
													type="file"
													id="fileImageEdit"
													name="AreaImage"
													accept="image/*"
													onChange={this.showPreviewImageCommon.bind(this)}
												/>
												<div className="white-space-8"></div>
												<p className="color-white">Subir imagen</p>
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="white-space-8"></div>
						<div className="row">
							<div className="input-form-content row auto align-center justify-start width-30">
								<div className="column">
									<label className="container-check">
										<input
											type="checkbox"
											id="pausar"
											checked={this.state.pausar ? true : false}
											name="pausado"
											onChange={(event) => this.updateData({ pausar: event.target.checked })}
										/>
										<span className="checkmark"></span>
									</label>
								</div>
								<div className="column">
									<h5>
										<b>Pausar reservas</b>
									</h5>
								</div>
							</div>
							<div className="align-center row full space-16">
								<div className="column full">
									<textarea
										name="motivo"
										className="textarea textarea-small input input-modals"
										cols="50"
										rows="5"
										autoComplete="off"
										value={this.state.motivo}
										onChange={(event) => this.updateData({ motivo: event.target.value })}
									></textarea>
								</div>
							</div>
						</div>
						<div className="white-space-8"></div>
						<div className="input-form-content row full align-center justify-start">
							<div className="column">
								<label className="container-check">
									<input
										type="checkbox"
										id="activar"
										checked={this.state.activo ? true : false}
										name="activo"
										onChange={(event) => this.updateData({ activo: event.target.checked })}
									/>
									<span className="checkmark"></span>
								</label>
							</div>
							<div className="column">
								<h5>
									<b>Activar área común</b>
								</h5>
							</div>
						</div>
						<div className="white-space-16"></div>
					</div>
				</div >
			</div >
		);
	};
};

export default CommonAreasEddit;